import React from 'react';
import Api from '../../services/Api';
import Availability from './Availability';
import Loading from '../Loading';
import { withProductConfig } from '../../hooks/ProductConfigContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';

export class SummaryAvailability extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            avail: null,
            fetchingPrice: true,
            stockingType: props.stockingType
        }
    }

    componentDidMount() {
        this.mounted = true;
        this.getSummaryAvailability();
    }

    setMountedState = (state, callback) => {
        if (this.mounted)
            this.setState(state, () => callback && callback());
    }

    getSummaryAvailability = () => {
        this.setMountedState({ fetchingPrice: true });

        const availabilityRequest = this.getAvailabilityRequest();
        return Api.fetch(`/api/products/GetDetailedAvailability`, { method: 'POST', body: JSON.stringify(availabilityRequest) }, false)
            .then(this.handleResponse).then(this.loadSummaryAvailability);
    }

    handleResponse(res) {     

        try {
            if (res)
                return res.json();
        } catch (error) {
                      
        }
    }

    getAvailabilityRequest = () => {
        return {
            customerId: this.props.customer.id,
            storefront: this.props.userStorefront,
            storefrontId: this.props.StorefrontConfig.storefront.id,
            company: this.props.customer.companyCode,
            sku: this.props.sku,
            id: this.props.productId,
            stockingType: this.props.stockingType,
            transactionQuantity: this.props.quantity?.toString() || "1",
            implementationId: this.props.StorefrontConfig.storefront.implementationId,
            useBranchStockingType: this.props.productConfig.settings.UseBranchStockingType,
            countryCode: this.props.customer.address?.country,
            OverrideBUDescription: this.props.productConfig.settings.OverrideBUDescription,
            factorVirtualLocations: this.props.StorefrontConfig.settingsList.ShowVirtualLocations == '1',
            useAssignedBranches: this.props.StorefrontConfig.settingsList.UsesAssignedBranches == '1'
        };
    }

    loadSummaryAvailability = (resp) => {
        this.setMountedState({ fetchingPrice: false });
        if (resp) {
            this.setMountedState({ avail: resp });
        }
    }

    render() {
        const { avail } = this.state;
        const localized = this.props.productConfig.labels;
        return (
            <React.Fragment>
                {
                    this.state.fetchingPrice &&
                    <Loading />
                }
                {
                    avail &&
                    <div>
                        <div className="label">{localized.AvailabilityByLocation_Label}</div>
                        <table id="avail_by_location">
                            <tbody>
                                {avail.branchAvailabilities.map((s, key) =>
                                    <tr key={key}>
                                        <td>
                                            <Availability availability={s.availabilityStatus} asIcon={false} />
                                        </td>
                                        <td>
                                            {
                                                this.props.productConfig.settings.ShowUseUpQuantity === true
                                                && this.state.stockingType === "U"
                                                && s.quantityAvailable > 0 &&
                                                <div style={{ whiteSpace: 'nowrap', marginTop: '4px' }}>
                                                        <FontAwesomeIcon icon={faExclamationTriangle} color="orange" /> {localized.QuantityAvailableLabel.replace("{0}", s.quantityAvailable)}
                                                </div>
                                            }
                                        </td>
                                        <td style={{ paddingLeft: "1.5rem" }}>
                                            <span> {s.IsVirtual ? localized.VirtualLocations : s.description} </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </React.Fragment>

        );
    }
}

export default withStorefrontConfig(withProductConfig(SummaryAvailability))